exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".checkout .realexIFrame{border-width:0px;width:100%;margin-top:10px}.checkout .wrapIframeRealex-ios{position:fixed;width:100%;height:100%;top:0px;left:0px;transition:all .3s ease-in-out 0s;z-index:1000;background:rgba(0,0,0,.7);overflow:auto;-webkit-overflow-scrolling:touch}.checkout .realexIFrame-ios{z-index:10001;position:absolute;transition:transform .5s ease-in-out 0s;transform:scale(1);opacity:1;top:0px;left:0px;width:100% !important;margin-left:0px;background-color:#fff;-webkit-overflow-scrolling:touch}.checkout .flex-justify-space-between{justify-content:space-between}.checkout .total p{font-weight:bold}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/containers/Checkout/checkout.scss
// module id = 774
// module chunks = 5